import { render, staticRenderFns } from "./AddCPage.vue?vue&type=template&id=4f1777ad&scoped=true&"
import script from "./AddCPage.vue?vue&type=script&lang=js&"
export * from "./AddCPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCPage.vue?vue&type=style&index=0&id=4f1777ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1777ad",
  null
  
)

export default component.exports